<template>
    <div class="container mortgage-calculator" :class="calculatorName">

		<div class="row justify-content-center calculator-header">
			<CalculatorHeader>
				<h2>Right to Buy Discount Calculator</h2>
				<h5>NO CREDIT CHECKS!</h5>
				<h5>Fill out the few details below to see how we could help you achieve a mortgage</h5>
			</CalculatorHeader>
		</div>
		<div class="row justify-content-center calculator-body">
			<div class="col-md-10 col-xl-8">
				<form class="calculator-container">

					<div class="mt-5" @keyup="resetCalculation" @change="resetCalculation">
						
						<transition name="fade-x" mode="out-in">
							<InputElement
								fieldText="What is the current value of your property?"
							>
							<InputTypeNumber currencyPlaceholder v-model="propertyValue"/>
							</InputElement>
						</transition>

						<transition name="fade-x" mode="out-in">
							<div class="row mb-5" v-if="propertyValue > 0">
							<div class="col-md-6 col-lg-4">Type of home</div>
							<div class="col-md-6 col-lg-8">
								<DropdownMenu :dropdownOptions="dropdownOptions" v-model="propertyType"/>
							</div>
							</div>
						</transition>

						<transition name="fade-x" mode="out-in">
							<div class="row mb-5" v-if="propertyValue > 0 && propertyType !== ''">
							<div class="col-md-6 col-lg-4">Where is your property located?</div>
							<div class="col-md-6 col-lg-8">
								<DropdownMenu :dropdownOptions="dropdownOptionsRegions" v-model="region"/>
							</div>
							</div>
						</transition>

						<transition name="fade-x" mode="out-in">
							<CheckBox
								v-if="propertyValue > 0 && propertyType !== '' && region === 'eastern'"
								id="watfordResident"
								text="Do you live in the district of Watford? (Leave Blank if no)"
								v-model="watfordResident"
								:class="{ checked: watfordResident }"
							/>
						</transition>

						<transition name="fade-x" mode="out-in">
							<CheckBox
								v-if="propertyValue > 0 && propertyType !== '' && region === 'southeast'"
								id="seResident"
								text="Do you live in the any of the following: Chiltern, Epsom & Ewell, Hart, Oxford, Reading, Reigate & Banstead, Tonbridge & Malling, Vale of the White Horse and West Berkshire? (Leave Blank if no)"
								v-model="seResident"
								:class="{ checked: seResident }"
							/>
						</transition>

						<transition name="fade-x" mode="out-in">
							<CheckBox
								v-if="propertyValue > 0 && propertyType !== '' && region === 'london'"
								id="londonResident"
								text="Do you live in the boroughs of Barking and Dagenham and Havering? (Leave Blank if no)"
								v-model="londonResident"
								:class="{ checked: londonResident }"
							/>
						</transition>

						<transition name="fade-x" mode="out-in">
							<div
								v-if="propertyValue > 0 && propertyType !== ''"
								class="mb-5"
							>
							<InputElement
								fieldText="How many years have you been a tenant?"
							>
								<input class="form-control" type="text" v-model="years">
							</InputElement>

							</div>
						</transition>

						<transition name="fade-x" mode="out-in">
							<div class="row mt-5" v-if="propertyValue > 0 && propertyType !=='' && years > 0">
								<div class="col-md-6 col-lg-4 fw-bold">Why are you using the calculator today</div>
								<div class="col-md-6 col-lg-8 fcs-grid-long">
									<DropdownMenu :dropdownOptions="dropdownOptionsReason" v-model="calcReason1">
								</div>
							</div>
						</transition>   

						<transition name="fade-x" mode="out-in">
							<div class="row mt-5 mb-5" v-if="propertyValue > 0 && propertyType !=='' && years > 0">
								<div class="col-md-6 col-lg-4 fw-bold">When will you be ready to move forward?</div>
								<div class="col-md-6 col-lg-8 fcs-grid-long">
									<DropdownMenu :dropdownOptions="dropdownOptionsMove" v-model="calcReason2">
								</div>
							</div>
						</transition>

						<transition name="scale-in" mode="out-in">
							<div
								v-if="propertyValue > 0 && propertyType !=='' && years > 0"
								class="text-center mt-5 mb-3"
							>
								<div class="btn calc-btn-secondary" @click="calculate">CALCULATE</div>
							</div>
						</transition>

					</div>							

					<transition name="fade-y" mode="out-in">
						<div v-if="calcCompleted">

							<ResultsContainer class="mt-5 mb-5 calc-results-box">
								<h5 v-html="this.result"></h5>
							</ResultsContainer>

							<SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody" />

						</div>
					</transition>

				</form>
			</div>				
		</div>

    </div>
</template>

<script>
import CalculatorHeader from '@/components/utilities/calculatorHeader.vue'
import CheckBox from '@/components/utilities/checkBox.vue'
import DropdownMenu from '@/components/utilities/dropdownMenu.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'

export default {
	components: {
		CalculatorHeader,
		CheckBox,
		DropdownMenu,
		InputElement,
		InputTypeNumber,
		ResultsContainer,
		SubmissionForm				
	},	
    data() {
        return {
			calculatorName: 'right-to-buy-discount-calculator',
			propertyValue: 0,
			propertyType: '',
			region: '',
			londonResident: false,
			watfordResident: false,
			seResident: false,
			years: 0,
			dropdownOptions: [
				{ value: '', text: "---- Choose one ----" },
				{ value: 'house', text: "House" },
				{ value: 'flat', text: "Flat" }
			],
			dropdownOptionsRegions: [
				{ value: '', text: "---- Choose one ----" },
				{ value: 'northeast', text: "North East" },
				{ value: 'northwest', text: "North West" },
				{ value: 'yorkshire', text: "Yorkshire and the Humber" },
				{ value: 'eastmidlands', text: "East Midlands" },
				{ value: 'westmidlands', text: "West Midlands" },
				{ value: 'eastern', text: "Eastern" },
				{ value: 'southeast', text: "South East" },
				{ value: 'southwest', text: "South West" },
				{ value: 'london', text: "London" }
			],
			minYears: 3,					//minimum years resident in council property
			maxDiscountPerc: 70,				//maximum percentage
			maxDiscount: '', 			//maximum possible discount
			
			//House settings
			houseDiscountPerc: 35,			//house discount start percentage
			housePercIncreasePerYear: 1, 	//discount percentage per additional year from minimum (house)

			//Flat settings
			flatDiscountPerc: 50,			//Flat discount start percentage
			flatPercIncreasePerYear: 2,	    //discount percentage per additional year from minimum (flat)
			calcCompleted: false,

			result: '',
			calculatedDiscountPerc: 0,
			discountAmount: 0,
			purchaseAmount: 0,
			calculatorReasonTitle: null,
			calculatorReasonResults: null,
			calcReason1: "",
			calcReason2: "",
			listName: "",
			emailAddress: "",
			consent: "",
			dropdownOptionsReason: [
				{value: "Please select an option", text: "Please select an option"},
				{value: "I'm ready to move forward with a mortgage", text: "I'm ready to move forward with a mortgage"},
				{
				value: "I'm not ready for a mortgage but am curious about what I could borrow",
				text: "I'm not ready for a mortgage but am curious about what I could borrow"
				},
				{
				value: "I'm starting to save for a house and want to know what to aim for",
				text: "I'm starting to save for a house and want to know what to aim for"
				},
				{
				value: "I need to understand a what I can afford before house shopping",
				text: "I need to understand a what I can afford before house shopping"
				},



			],

			dropdownOptionsMove: [
				{value: "Please select an option", text: "Please select an option"},
				{value: "12+ months", text: "12+ months"},
				{value: "6-12 months", text: "6-12 months"},
				{value: "In the next 3 months", text: "In the next 3 months"},
				{value: "As soon as possible", text: "As soon as possible"},
			],
		}
    },
    methods: {
        calculate() {
            if( this.years < this.minYears ) {
				this.result = `To be eligible for Right to Buy you must have been a council tenant for a minimum of 3 years.`
			} else {

				if (this.region === 'northeast'){
				this.maxDiscount = 22000;
				} else if (this.region === 'northwest') {
				this.maxDiscount = 26000;
				} else if (this.region === 'yorkshire') {
				this.maxDiscount = 24000;
				} else if (this.region === 'eastmidlands') {
				this.maxDiscount = 24000;
				} else if (this.region === 'westmidlands') {
				this.maxDiscount = 26000;
				} else if (this.region === 'eastern') {
				if(this.watfordResident) {
					this.maxDiscount = 16000;
				} else {
					this.maxDiscount = 34000;
				}
				} else if (this.region === 'southeast') {
				if(this.seResident) {
					this.maxDiscount = 16000;
				} else {
					this.maxDiscount = 38000;
				}
				} else if (this.region === 'southwest') {
				this.maxDiscount = 30000;
				} else {
				this.maxDiscount = 16000;
				if(this.londonResident) {
					this.maxDiscount = 38000;
				} else {
					this.maxDiscount = 16000;
				}
				}

				if( this.propertyType === 'house' ) {
				this.calculatedDiscountPerc = this.houseDiscountPerc + ( this.housePercIncreasePerYear * ( this.years - this.minYears ))
				}

				if( this.propertyType === 'flat' ) {
				this.calculatedDiscountPerc = this.flatDiscountPerc + ( this.flatPercIncreasePerYear * ( this.years - this.minYears ))
				}

				//Check if the calculated discount percentage has not breached the maximum discount percentage
				if( this.calculatedDiscountPerc > this.maxDiscountPerc ) {
				this.calculatedDiscountPerc = this.maxDiscountPerc //update discount to maximum discount percentage
				}

				this.discountAmount = ( this.propertyValue / 100 ) * this.calculatedDiscountPerc

				//Check if the calculated discount has not breached the maximum discount
				if( this.discountAmount > this.maxDiscount ) {
				this.discountAmount = this.maxDiscount //update discount to maximum discount
				//recalculate maximum percentage
				this.calculatedDiscountPerc = ( this.discountAmount / this.propertyValue ) * 100
				}

				this.purchaseAmount = ( this.propertyValue - this.discountAmount )
				this.result =
					`
							<h5>Discount: ${this.calculatedDiscountPerc.toFixed(0)}%</h5>
							<h5>Giving a discount of £${this.discountAmount}</h5>
							<h5>Meaning you could buy your home for £${this.purchaseAmount}</h5>
						`

			}
			this.calcCompleted = true;
        },
        removeHyphensToUpperCase(str) {
            return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) { return (prep && ' ') + letter.toUpperCase(); });
		},
		resetCalculation() {
			this.calcCompleted = false;
		}				
    },	
    computed: {
		showPropertyDetails() {
			return this.householdIncome && (this.dependantChildren || this.dependantChildren === 0);
		},		
		showCalculateButton() {
			return this.discountedPrice && (this.extraDeposit || this.extraDeposit === 0)
		},
        householdIncome() {
            let annualIncome1 = this.annualIncome1 ? this.annualIncome1 : 0;
            let annualIncome2 = this.annualIncome2 ? this.annualIncome2 : 0;

            return annualIncome1 + annualIncome2;
        },
        totalRequired() {
            let discountedPrice = this.discountedPrice ? this.discountedPrice : 0;
            let extraDeposit = this.extraDeposit ? this.extraDeposit : 0;

            return discountedPrice - extraDeposit;
        },
		collateMessageBody() {
			let calculatorData = {
				calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
				calculatorResults:
					`
							Property Value: £${parseInt(this.propertyValue)}
				Property Type: £${this.propertyType}
							Where is your property located? ${this.region}
							How long you are the tenant? ${this.years} - years

							Discount: ${this.calculatedDiscountPerc.toFixed(0)}%
							Giving a discount of: £${parseInt(this.discountAmount)}
							Meaning you could buy your home for: £${parseInt(this.purchaseAmount)}
				Why are you using the calculator today: ${this.calcReason1}
				When will you be ready to move forward: ${this.calcReason2}
						`
			}

			return calculatorData;
		}		
    }
}
</script>

<style lang="scss">
	@import './styles/calcs.scss';
</style>